export type ICountryCode = string;

interface IPhoneNumbers {
  ts: string; // ts - Technical support (техподдержка)
  sd: string; // sd - Sales department (отдел продаж),
  pd: string; // pd - Partner departments (партнерский отдел)
}

export const phoneNumsLib: Record<ICountryCode, IPhoneNumbers> = {
  RU: {
    ts: '+7 (495) 669-67-21',
    sd: '+7 (495) 148-50-22',
    pd: '+7 (495) 148-50-11'
  },
  UZ: {
    ts: '+998 (78) 113-26-50',
    sd: '+998 (78) 113-66-61',
    pd: '+998 (78) 113-66-68'
  },
  KZ: {
    ts: '+7 (708) 905-70-02',
    sd: '+7 (708) 905-70-02',
    pd: '+7 (708) 905-70-02'
  }
};
